import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { Bar } from 'react-chartjs-2';
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  useTheme,
  makeStyles,
  colors,
  TextField,
  MenuItem
} from '@material-ui/core';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import MyContext from 'src/MyContext'

var moment = require('moment');
const day =  24 * 3600 * 1000
const week = Date.now() - (7 * day)
const month = Date.now() - (30 * day)
const year = Date.now() - (365 * day)

const time_options = [{'name': 'Past 7 Days', 'value': week}, {'name': 'Past Month', 'value': month}, {'name': 'Past Year', 'value': year}]

const useStyles = makeStyles(() => ({
  root: {}
}));

const Sales = ({ className, ...rest }) => {
  const classes = useStyles();
  const theme = useTheme();
  const [timeValue, setTimeValue] = React.useState(week)
  const [timeName, setTimeName] = React.useState('Last 7 Days')


  function compare2(a, b) {

      
      if (a.val > b.val) {
        return 1
      } else if (b.val > a.val) {
        return -1
      }
      return 0;
  }
    
  function sortItems(v, s) {
      //console.log('try sorting')
      //console.log(v)
      //console.log(s)
      var o = v
      o.sort((a, b) => compare2(a, b))
      return o
  }

  function produceData(dateRange, lst) {
    //alert('range is' + dateRange + ' and now is ' + Date.now())
    var dropoffDict = {}
    var pickupDict = {}
    var labelsList = []
    var labelsDict = {}

    lst.map((item, idx) => {
      if ('earlyDrop' in item && 'earlyPick' in item) {
        let vDrop = moment(item.earlyDrop).valueOf()
        let vPick = moment(item.earlyPick).valueOf()
        if (vDrop > dateRange && item.state >= 9) {
          let monthFormat = moment(item.earlyDrop).format('DD/MM')
          if (monthFormat in dropoffDict) {
            dropoffDict[monthFormat] += 1
          } else {
            dropoffDict[monthFormat] = 1
          }
          if (monthFormat in labelsDict) {

          } else {
            labelsDict[monthFormat] = 1
            labelsList.push({'text': monthFormat, 'val': vDrop})
          }
        }
        if (vPick > dateRange && item.state >= 8) {
          let monthFormat = moment(item.earlyPick).format('DD/MM')
          if (monthFormat in pickupDict) {
            pickupDict[monthFormat] += 1
          } else {
            pickupDict[monthFormat] = 1
          }
          if (monthFormat in labelsDict) {

          } else {
            labelsDict[monthFormat] = 1
            labelsList.push({'text': monthFormat, 'val': vPick})
          }
        }
      }
    })

    let sorted = sortItems(labelsList)

    var final_dropoff = []
    var final_pickup = []
    var final_labels = []

    sorted.map((item, idx) => {
      final_labels.push(item.text)
      if (item.text in dropoffDict) {
        final_dropoff.push(dropoffDict[item.text])
      } else {
        final_dropoff.push(0)
      }
      if (item.text in pickupDict) {
        final_pickup.push(pickupDict[item.text])
      } else {
        final_pickup.push(0)
      }

    })

    return {
      datasets: [
        {
          backgroundColor: colors.indigo[500],
          data: final_dropoff,
          label: 'Deliveries'
        },
        {
          backgroundColor: colors.grey[200],
          data: final_pickup,
          label: 'Pickups'
        }
      ],
      labels: final_labels
    };

  }

  const data = {
    datasets: [
      {
        backgroundColor: colors.indigo[500],
        data: [18, 5, 19, 27, 29, 19, 20],
        label: 'This year'
      },
      {
        backgroundColor: colors.grey[200],
        data: [11, 20, 12, 29, 30, 25, 13],
        label: 'Last year'
      }
    ],
    labels: ['1 Aug', '2 Aug', '3 Aug', '4 Aug', '5 Aug', '6 Aug']
  };

  const options = {
    animation: false,
    cornerRadius: 20,
    layout: { padding: 0 },
    legend: { display: false },
    maintainAspectRatio: false,
    responsive: true,
    scales: {
      xAxes: [
        {
          barThickness: 12,
          maxBarThickness: 10,
          barPercentage: 0.5,
          categoryPercentage: 0.5,
          ticks: {
            fontColor: theme.palette.text.secondary
          },
          gridLines: {
            display: false,
            drawBorder: false
          }
        }
      ],
      yAxes: [
        {
          ticks: {
            fontColor: theme.palette.text.secondary,
            beginAtZero: true,
            min: 0
          },
          gridLines: {
            borderDash: [2],
            borderDashOffset: [2],
            color: theme.palette.divider,
            drawBorder: false,
            zeroLineBorderDash: [2],
            zeroLineBorderDashOffset: [2],
            zeroLineColor: theme.palette.divider
          }
        }
      ]
    },
    tooltips: {
      backgroundColor: theme.palette.background.default,
      bodyFontColor: theme.palette.text.secondary,
      borderColor: theme.palette.divider,
      borderWidth: 1,
      enabled: true,
      footerFontColor: theme.palette.text.secondary,
      intersect: false,
      mode: 'index',
      titleFontColor: theme.palette.text.primary
    }
  };

  return (
    <MyContext.Consumer>{context => (
    <Card
      className={clsx(classes.root, className)}
      {...rest}
    >
      <CardHeader
        action={(
          <TextField select 
          style={{width: 120}}
          value={timeValue}
          onChange={(x) => {
            setTimeName(x.target.name)
            setTimeValue(x.target.value)
          }}
        >
          {time_options.map((item, idx) => {
            return (<MenuItem value={item.value}>{item.name}</MenuItem>)
          })}
        </TextField>
        )}
        title="Pickup and Delivery History"
      />
      <Divider />
      <CardContent>
        <Box
          height={400}
          position="relative"
        >
          <Bar
            data={produceData(timeValue, context.adminJobs)}
            options={options}
          />
        </Box>
      </CardContent>
      <Divider />

    </Card>
    )}</MyContext.Consumer>
  );
};

Sales.propTypes = {
  className: PropTypes.string
};

export default Sales;
